export default __webpack_public_path__ + "static/media/navbar-two-factor-authentication-dark.c2ac585f.svg";